import { generateUuid } from '../../helpers/strings';
export const getCurrentViewTime = () => Math.round(Date.now() / 1000);
export const fetchSubmitId = (state) => {
    if (state.submitId) {
        return Promise.resolve();
    }
    const xhr = new XMLHttpRequest();
    xhr.open('POST', window.endpoints.submitId);
    xhr.responseType = 'text';
    xhr.setRequestHeader('Accept', 'text/plain');
    xhr.setRequestHeader('Content-Type', 'application/json');
    const viewTime = getCurrentViewTime();
    return new Promise((resolve) => {
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) {
                return;
            }
            state.vt = viewTime;
            const submitId = typeof xhr.response === 'string' ? xhr.response.trim() : '';
            if (xhr.status >= 200 && xhr.status < 300 && submitId.length > 0) {
                state.submitId = submitId;
            }
            resolve();
        };
        xhr.send(JSON.stringify({
            vt: viewTime,
            ft: state.formName,
        }));
    });
};
export const resolveSubmitId = (state) => state.submitId || generateUuid().replace(/-/g, '');
export const resolveViewTime = (state) => state.vt || getCurrentViewTime();
